import { render, staticRenderFns } from "./deletedListing.vue?vue&type=template&id=4b60dd0a&scoped=true"
import script from "./deletedListing.vue?vue&type=script&lang=js"
export * from "./deletedListing.vue?vue&type=script&lang=js"
import style0 from "./deletedListing.vue?vue&type=style&index=0&id=4b60dd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b60dd0a",
  null
  
)

export default component.exports